







import { Vue, Component } from 'vue-property-decorator';
import LifecycleModule from '@/store/modules/lifecycle';
import ToastNotification from '@/components/ToastNotification/index.vue';

@Component({
  components: { ToastNotification },
})
export default class App extends Vue {
}
